export default __webpack_public_path__ + "f5e1e85b241af818bc0d4aa2396b408f.svg";